import { render, staticRenderFns } from "./PlantillaLogin.vue?vue&type=template&id=1c730840&scoped=true&"
import script from "./PlantillaLogin.vue?vue&type=script&lang=js&"
export * from "./PlantillaLogin.vue?vue&type=script&lang=js&"
import style0 from "./PlantillaLogin.vue?vue&type=style&index=0&id=1c730840&scoped=true&lang=css&"
import style1 from "./PlantillaLogin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c730840",
  null
  
)

export default component.exports